import React from "react"

import Layout from "../components/allstar/layout"
import SectionHero from "../components/allstar/resource/press-release-template/section-hero"
import SectionBody from "../components/allstar/resource/press-release-template/section-body"
import { useYear } from "../context/YearContext"
import { graphql } from "gatsby"

const PressReleaseTemplatePage = props => {
  const { selectedYear } = useYear()
  return (
    <Layout
      location={props.location}
      title={"Press Release Template"}
      isResourceSite
    >
      <SectionHero year={selectedYear} data={props.data} />
      <SectionBody year={selectedYear} />
    </Layout>
  )
}

export default PressReleaseTemplatePage

export const query = graphql`
  query pressReleaseTemplatePage {
    allBadges: allFile(
      filter: { relativeDirectory: { eq: "allstar/badges" } }
    ) {
      edges {
        node {
          name
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
`
